import PropTypes from "prop-types";
import Counter from "../../../shared/Counter/Counter";

const ProductCatalogueQuantity = ({ setQuantity, disabled }) => {
  return <Counter startValue={1} min={1} onChange={setQuantity} disabled={disabled} />;
};

ProductCatalogueQuantity.propTypes = {
  setQuantity: PropTypes.func,
  disabled: PropTypes.bool,
};

export default ProductCatalogueQuantity;
